export default __webpack_public_path__ + "static/media/biofit-builder-series-EB.21d3e978.png";